import { render, staticRenderFns } from "./drawing-selected-thumbnail.component.vue?vue&type=template&id=58b51114&scoped=true&"
import script from "./drawing-selected-thumbnail.component.ts?vue&type=script&lang=ts&"
export * from "./drawing-selected-thumbnail.component.ts?vue&type=script&lang=ts&"
import style0 from "./drawing-selected-thumbnail.component.scss?vue&type=style&index=0&id=58b51114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b51114",
  null
  
)

export default component.exports